import React, { Component } from 'react'

export class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <div className="footer-content">
        <div className="bestel-logo">
          <img src={require('../../assets/img/bestel-logo.svg')} alt=""/>
        </div>
          <p>Bonanza Agro Industries webshop by <a rel="noopener noreferrer" href="https://bestel.sr" target='_blank'>bestel.sr</a> </p>
          <div className="social-links">
            <a rel="noopener noreferrer" href="https://www.facebook.com/bestel.sr/" target='_blank'><i className="fab fa-facebook-f"></i></a>
            <a rel="noopener noreferrer" href="https://www.instagram.com/bestel.sr/" target='_blank'><i className="fab fa-instagram"></i></a>
            <a rel="noopener noreferrer" href="mailto: info@bestel.sr"><i className="fas fa-at"></i></a>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer
